import { useMutation, useQuery } from 'react-query';
import axiosClient from './axiosClient';

export const fileApi = {
  create(data, config) {
    return axiosClient.post('/files', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      ...config,
    });
  },
  //
  delete(params) {
    console.log(params)
    return axiosClient.delete('/files', { data: { ids: params } });
  },
  getFileGroups(params) {
    return axiosClient.get('/file/groups', { params });
  },
  rotate({ id, rotate }) {
    return axiosClient.patch(`/files/${id}/rotate`, {}, { params: { rotate } });
  },
  getAllfiles() {
    return axiosClient.get(`files`)
  }
};

export const useCreateFile = () => {
  return useMutation({
    mutationFn: ({ data, config }) => fileApi.create(data, config),
  });
};
//

export const useDeleteFile = () => {
  return useMutation(fileApi.delete);
};

export const useFileGroups = ({ params, options } = {}) => {
  return useQuery({
    queryKey: ['file', 'groups', params],
    queryFn: () => fileApi.getFileGroups(params),
    ...options,
  });
};

export const useRotateFile = () => {
  return useMutation(fileApi.rotate);
};

export const useGetAllfiles = () => {
  return useQuery({
    queryKey: ['files'],
    queryFn: () => fileApi.getAllfiles(),
  })
}